import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { ApiEnvelope, CustomDemographics } from '../types';
import { CUSTOM_DEMOGRAPHICS_KEY } from './constants';

/** Resolves `null` until the member's demographics have been saved for this org. */
const useGetCustomDemographics = (member_id: number | null | undefined) => {
    const req = useRequest();

    const action = useCallback(() => {
        return req<ApiEnvelope<CustomDemographics | null>>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/member/${member_id}/custom-demographics/`
        });
    }, [member_id, req]);

    return useQuery({
        queryKey: [CUSTOM_DEMOGRAPHICS_KEY, member_id],
        queryFn: action,
        select: (response) => response.data,
        enabled: !!member_id
    });
};

export default useGetCustomDemographics;
